<template>
  <OAuthApplicationCreate @closed="router.push({ name: 'integrations' })" />
</template>
<script setup>
import { useHead } from '@unhead/vue';
import { useRouter } from 'vue-router';

import OAuthApplicationCreate from '@/components/OAuthApplicationCreate.vue';

useHead({ title: 'Integrations - Create New Integration - Crossbeam' });

const router = useRouter();
</script>
